import type { PartType } from '../miners/PartType'

export enum SparePartStatus {
  InStock = 'In Stock',
  Used = 'Used',
  Broken = 'Broken',
  DeadOnArrival = 'Dead On Arrival',
}

export interface BulkSparePartsResult {
  success: boolean
  errors: string[]
}

export interface ISparePartDashboard {
  id: number
  owner: string | null
  site: string | null
  part_type: string
  part_sn: string | null
  part_model: string | null
  status: string
  price: number | null
  miner_used_on: string | null
  miner_coming_from: string | null
}

export interface ISparePart {
  id: number
  customer: {
    id: number
    name: string
  }
  site: {
    site_id: string
    site_name?: string
  }
  part_type: PartType
  part_sn: string | null
  part_model: string | null
  part_model_version: string | null
  status: SparePartStatus
  price: number | null
  miner_used_on: {
    id: number
    sn: string
    work_order_number: string
  }
  miner_coming_from: {
    id: number
    sn: string
    work_order_number: string
  }
  refurbished: boolean
  archived: boolean
}

export interface ISparePartHistory {
  spare_part_id: number
  status: SparePartStatus
  action: string
  action_user: string
  action_timestamp: string
}
